import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import "./index.css";

import "./localization/i18n";

import App from "./App";
import { store } from "./redux/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLDivElement,
);

root.render(
  <Provider store={store}>
    <ToastContainer position="top-right" newestOnTop />
    <Router>
      <App />
    </Router>
  </Provider>,
);
